export default __webpack_public_path__ + "static/media/Doc-close.93ae3edf.svg";